var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('menu-header'),_c('router-view',{staticClass:"pt-16 lg:pt-16 lg:pl-64 min-h-screen padding-bottom"}),_c('snack-bar'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }